import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { cn } from '../lib/utils';
const tiers = [{
  name: 'Observer',
  price: '€0',
  period: '/month',
  description: 'For casual stargazers starting their journey.',
  features: ['Basic star map', '3 alerts/month', 'Community access', 'Standard support'],
  cta: 'Start Free',
  highlight: false
}, {
  name: 'Navigator',
  price: '€9',
  period: '/month',
  description: 'The complete toolkit for serious enthusiasts.',
  features: ['Full Astral Lens', 'Unlimited alerts', 'Satellite tracking', 'Equipment matcher', 'Ad-free experience'],
  cta: 'Get Navigator',
  highlight: true
}, {
  name: 'Astronomer',
  price: '€24',
  period: '/month',
  description: 'Professional grade tools for deep space tracking.',
  features: ['Everything in Navigator', 'API access', 'Astrophotography tools', 'Priority support', 'Early feature access'],
  cta: 'Go Pro',
  highlight: false
}];
export function PricingSection() {
  return <section id="pricing" className="py-24 relative z-10" data-id="element-119">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-120">
        <div className="text-center mb-16" data-id="element-121">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-122">
            Choose Your Orbit
          </h2>
          <p className="text-slate-400" data-id="element-123">
            Transparent pricing for every level of exploration.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center" data-id="element-124">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={cn('relative p-8 rounded-2xl backdrop-blur-md border flex flex-col', tier.highlight ? 'bg-slate-900/60 border-cyan-500/50 shadow-[0_0_30px_rgba(6,182,212,0.15)] scale-105 z-10' : 'bg-slate-900/40 border-slate-800 hover:border-slate-700')} data-id="element-125">
              {tier.highlight && <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-cyan-500 text-white text-xs font-bold uppercase tracking-wider rounded-full shadow-lg" data-id="element-126">
                  Most Popular
                </div>}

              <h3 className="text-xl font-bold text-white mb-2" data-id="element-127">{tier.name}</h3>
              <div className="flex items-baseline mb-4" data-id="element-128">
                <span className="text-4xl font-bold text-white" data-id="element-129">
                  {tier.price}
                </span>
                <span className="text-slate-500 ml-2" data-id="element-130">{tier.period}</span>
              </div>
              <p className="text-slate-400 text-sm mb-8 h-10" data-id="element-131">
                {tier.description}
              </p>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-132">
                {tier.features.map((feature, i) => <li key={i} className="flex items-start text-sm text-slate-300" data-id="element-133">
                    <Check className="w-5 h-5 text-cyan-400 mr-3 flex-shrink-0" data-id="element-134" />
                    {feature}
                  </li>)}
              </ul>

              <button className={cn('w-full py-3 rounded-xl font-medium transition-all duration-300', tier.highlight ? 'bg-cyan-500 text-white hover:bg-cyan-400 shadow-lg hover:shadow-cyan-500/25' : 'bg-slate-800 text-slate-200 hover:bg-slate-700 border border-slate-700')} data-id="element-135">
                {tier.cta}
              </button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}